module.exports = __webpack_public_path__ + "img/roboto-mono-light.9e9c4704.png";